$(document).on('click', '.bn_back', function(event) {
    event.preventDefault();
    history.back();
});